<template>
  <div class="bottom">
    <footer class="footer-embajadores">
      <div class="contenedor-textos">
        <small class="texto-footer derechos">
          {{
            (this.tipoPersona != 2 && this.tipoPersona != 5 && this.tipoPersona != 7)
              ? "© Todos los derechos reservados"
              : "© All rights reserved"
          }}
        </small>
        <small class="texto-footer contacto">
          {{
            (this.tipoPersona != 2 && this.tipoPersona != 5 && this.tipoPersona != 7)
              ? "Mail: contacto@hirembajadores.com Telefono: +52 55 5511 9910 Ext. 5055 y 5059."
              : "Email: contacto@hirembajadores.com Phone: +52 55 5511 9910 Ext. 5055 y 5059."
          }}
        </small>
        <small
          class="texto-footer"
          data-bs-toggle="modal"
          data-bs-target="#modalTerminosAvisos"
        >
          {{
            (this.tipoPersona != 2 && this.tipoPersona != 5 && this.tipoPersona != 7) ? "Aviso de privacidad" : "Privacy Notice"
          }}</small
        >
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      tipoPersona: null,
    };
  },
  mounted() {
    this.tipoPersona = this.$store.getters.tipoPersona;
  },
};
</script>

<style lang="scss" scoped>
.bottom {
  margin-top: auto;
}
.footer-embajadores {
  background-color: #696158;
  height: 50px;
}
.contenedor-textos {
  height: 100%;
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.texto-footer {
  color: #ffffff;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  padding: 15px;
}
.texto-footer:hover {
  text-decoration: underline;
}
.derechos {
  @extend .texto-footer;
  cursor: unset;
}
.derechos:hover {
  text-decoration: none;
}
.contacto {
  @extend .texto-footer;
  cursor: unset;
}
.contacto:hover {
  text-decoration: none;
}

@media (max-width: 512px) {
  .contenedor-textos {
    justify-content: center;
  }
  .texto-footer {
    font-size: 8px;
    padding: 10px;
  }
}
</style>
